import { Disclosure, Transition } from '@headlessui/react';
import { NavLink, useLocation } from 'react-router-dom';
import { TiArrowSortedDown } from 'react-icons/ti';
import { Tooltip } from 'antd';
import {
  MdOutlineInventory, MdDashboard, MdCategory, MdEmojiEvents, MdFeaturedPlayList, MdDateRange,
  MdDeviceHub,
  MdOutlineDevices,
  MdOutlineCategory,
} from 'react-icons/md';
import { GrTransaction } from 'react-icons/gr';
import { FaUserAlt, FaBoxOpen, FaUsers } from 'react-icons/fa';
import { BsSignpost2Fill } from 'react-icons/bs';
import { RiHome5Line, RiHomeWifiFill, RiNotification2Fill } from 'react-icons/ri';
import styles from './index.module.css';
import methodModel from '../../../methods/methods';
import { FiUsers } from 'react-icons/fi';
import { LuLayoutDashboard, LuUser } from 'react-icons/lu';
import { Routes } from '../../../methods/ApiRoutes';
import { IoIosSettings } from 'react-icons/io';
import { IoStatsChart } from 'react-icons/io5';
import { RiFileList3Line } from 'react-icons/ri';

function Html({
  ListItemLink, tabclass, isAllow, route, isOpen, user,
}) {
  const location = useLocation();

  const activecls = (tab) => {
    const url = window.location.href;
    let value = false;
    tab?.forEach((itm) => {
      if (url.includes(itm)) {
        value = true;
      }
    });
    return value;
  };

  const menus = [
    {
      name: 'Main Menu',
    },
    {
      name: 'Dashboard',
      icon: <LuLayoutDashboard className="text-[#CC9900] min-w-[30px] w-[30px] h-[30px] p-[6px]" />,
      url: '/dashboard',
      key: '',
      permission: 'Dashboard'
    },
    {
      name: 'Analytics',
      icon: <IoStatsChart className="text-[#CC9900] min-w-[30px] w-[30px] h-[30px] p-[6px]" />,
      url: '/analytics',
      key: '',
      permission: Routes.Analytics.permissionKey
    },
    {
      name: "Staff",
      icon: <LuUser className="text-[#CC9900] min-w-[30px] w-[30px] h-[30px] p-[6px]" />,
      url: "/staff",
      key: "",
      permission: Routes.Staff.permissionKey
    },
    {
      name: "Users",
      icon: <FaUsers className="text-[#CC9900] min-w-[30px] w-[30px] h-[30px] p-[6px]" />,
      url: "/user",
      key: "",
      permission: Routes.User.permissionKey
    },
    {
      name: "Venue Management",
      icon: <MdCategory className="text-[#CC9900] min-w-[30px] w-[30px] h-[30px] p-[6px]" />,
      url: `/${Routes.Venue.url}`,
      key: "",
      permission: Routes.Venue.permissionKey
    },
    {
      name: "Offers",
      icon: <MdFeaturedPlayList className="text-[#CC9900] min-w-[30px] w-[30px] h-[30px] p-[6px]" />,
      url: "/offer",
      key: "",
      permission: Routes.Offer.permissionKey
    },
    {
      name: "Transactions",
      icon: <GrTransaction className="text-[#CC9900] min-w-[30px] w-[30px] h-[30px] p-[6px]" />,
      url: "/transaction",
      key: "",
      permission: Routes.Transactions.permissionKey
    },
    {
      name: "Content Management",
      icon: <RiFileList3Line className="text-[#CC9900] min-w-[30px] w-[30px] h-[30px] p-[6px]" />,
      url: "/content-management",
      key: "",
      permission: Routes.Content.permissionKey
    },
    {
      name: "Notification",
      icon: <RiNotification2Fill className="text-[#CC9900] min-w-[30px] w-[30px] h-[30px] p-[6px]" />,
      url: "/notification",
      key: "",
      permission: Routes.Notification.permissionKey
    },
    {
      name: "Settings",
      icon: <IoIosSettings className="text-[#CC9900] min-w-[30px] w-[30px] h-[30px] p-[6px]" />,
      url: "/settings",
      key: "",
      permission: Routes?.settings.permissionKey
    },

  ];

  return (
    <div
      className={` ${isOpen && styles.sm_sidebar}`}
      component="siderbar"
    >
      <ul className="h-[calc(100vh-138px)] sidebar-height overflow-auto scrollbar_hide">
        {menus.map((itm, index) => (
          methodModel.hasPermission(user, itm?.permission, 'read') && <span key={index}>
            {itm.icon ? (
              <li className="mb-3">
                {itm.menu ? (
                  <>
                    {isAllow(
                      itm.menu.map((itm) => itm.key).toString(),
                    ) ? (
                      <Disclosure
                        as="div"
                        defaultOpen={activecls(
                          itm.menu.map((itm) => itm.url),
                        )}
                      >
                        {({ open }) => (
                          <>
                            <Tooltip placement="right" title={isOpen ? itm.name : ""}>
                            <Disclosure.Button className={`w-full px-4 py-2.5 rounded-r-xl border-l-4 border-transparent flex items-center justify-between gap-[12px] text-gray-300 hover:bg-white/5 hover:text-white transition-all duration-200 ${open ? 'text-white' : ''}`}>
                                <span className="text-sm font-medium text-inherit flex items-center gap-[12px] crm">
                                  {itm.icon}
                                  <span className="text-inherit leading-none sidebar_text">
                                    {itm.name}
                                  </span>
                                </span>
                                <TiArrowSortedDown
                                  className={`${open ? 'text-[#CC9900]' : '-rotate-90 transform text-gray-400'
                                    } h-4 w-4 transition-all duration-300`}
                                />
                              </Disclosure.Button>
                            </Tooltip>
                            <Transition
                              enter="transition duration-300 ease-in-out"
                              enterFrom="transform scale-95 opacity-0"
                              enterTo="transform scale-100 opacity-100"
                              leave="transition duration-300 ease-in-out"
                              leaveFrom="transform scale-100 opacity-100"
                              leaveTo="transform scale-95 opacity-0"
                            >
                              <Disclosure.Panel className="pl-[24px] mt-[4px] border-l border-white/5 ml-7">
                                <ul className="space-y-2">
                                  {itm.menu?.map((sitm, i) => (
                                    <>
                                      {isAllow(sitm.key) ? (
                                        <li key={i}>
                                          {' '}
                                          <NavLink
                                            className={(isActive) => `p-2.5 pl-4 rounded-r-md border-l-2 border-transparent block text-sm font-medium text-gray-400 hover:text-white hover:bg-white/5 cursor-pointer !no-underline transition-all duration-200 ${location?.pathname
                                              === sitm.url
                                              ? ' !text-[#CC9900] bg-[#CC9900]/10 !border-[#CC9900] !font-semibold' : ''}`}
                                            to={sitm.url}
                                          >
                                            <span
                                              className="text-inherit leading-none sidebar_text"
                                              title={sitm.name}
                                            >
                                              {sitm.name}
                                            </span>
                                          </NavLink>
                                        </li>
                                      ) : null}
                                    </>
                                  ))}
                                </ul>
                              </Disclosure.Panel>
                            </Transition>
                          </>
                        )}
                      </Disclosure>
                    ) : (
                      <></>
                    )}
                  </>
                ) : (
                  <>
                    {isAllow(itm.key) ? (
                      <Tooltip
                        placement="right"
                        color="#CC9900"
                        title={isOpen ? itm.name : ""}
                      >
                        <NavLink
                          to={itm.url}
                          className={(isActive) => `px-4 py-2.5 flex items-center gap-3 text-sm font-medium rounded-r-xl border-l-4 border-transparent text-gray-300 hover:bg-white/5 hover:text-white !no-underline transition-all duration-200 ${location?.pathname.includes(itm.url)
                            ? ' !text-[#CC9900] bg-[#CC9900]/10 !border-[#CC9900] !font-semibold' : ''}`}
                        >
                          {itm.icon}
                          <span className="text-inherit leading-none sidebar_text">
                            {itm.name}
                          </span>
                        </NavLink>
                      </Tooltip>
                    ) : (
                      <></>
                    )}
                  </>
                )}
              </li>
            ) : (
              <li>
                <h6
                  className={`${isOpen
                    ? 'py-[12px] '
                    : 'p-[12px]  text-md'
                    } text-xs font-medium text-[#fff]`}
                >
                  <span className=" sidebar_text text-center heading_block">
                    {' '}
                    {itm.name}
                    {' '}
                  </span>
                </h6>
              </li>
            )}
          </span>
        ))}
      </ul>
    </div>
  );
}

export default Html;
